import React from "react";

/** Мелкие SVG-иконки статистики/мета (без эмодзи). */

const base = (size) => ({
  width: size, height: size, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round",
});

export function EyeIcon({ size = 15 }) {
  return (
    <svg {...base(size)}>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function HeartIcon({ size = 15 }) {
  return (
    <svg {...base(size)}>
      <path d="M12 21s-7.5-4.6-10-9.2C.6 9 1.7 5.5 5 5c2-.3 3.5 1 4 2 .5-1 2-2.3 4-2 3.3.5 4.4 4 3 6.8C19.5 16.4 12 21 12 21z" />
    </svg>
  );
}

export function CommentIcon({ size = 15 }) {
  return (
    <svg {...base(size)}>
      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-9A8.4 8.4 0 1 1 21 11.5z" />
    </svg>
  );
}

export function PinIcon({ size = 13 }) {
  return (
    <svg {...base(size)}>
      <path d="M12 17v5M9 3h6l-1 7 3 3H7l3-3-1-7z" />
    </svg>
  );
}

/** Иконки рубрик (вместо эмодзи). */
export function CatIcon({ id, size = 13 }) {
  if (id === "update")
    return (<svg {...base(size)}><path d="M14 2l1.5 4.5L20 8l-4.5 1.5L14 14l-1.5-4.5L8 8l4.5-1.5L14 2z" /><path d="M5 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z" /></svg>);
  if (id === "thoughts")
    return (<svg {...base(size)}><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-9A8.4 8.4 0 1 1 21 11.5z" /><circle cx="9" cy="11.5" r=".6" fill="currentColor" /><circle cx="12" cy="11.5" r=".6" fill="currentColor" /><circle cx="15" cy="11.5" r=".6" fill="currentColor" /></svg>);
  // announce
  return (<svg {...base(size)}><path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" /><path d="M16 8a4 4 0 0 1 0 8" /></svg>);
}
